import { render } from "./PanelRightProperty.vue?vue&type=template&id=4c021600&scoped=true"
import script from "./PanelRightProperty.vue?vue&type=script&lang=js"
export * from "./PanelRightProperty.vue?vue&type=script&lang=js"

import "./PanelRightProperty.vue?vue&type=style&index=0&id=4c021600&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3dbeta/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c021600"]])

export default __exports__